import React from "react";
import ReactMarkdown from "react-markdown";

export default function TextLesson({ lesson, onCompleted }) {
  return (
    <div>
      <article
        className="prose prose-invert max-w-none prose-headings:font-display prose-headings:text-white prose-p:text-gray-200 prose-strong:text-white prose-a:text-[#93C5FD] prose-code:text-[#93C5FD]"
        data-testid="lesson-text"
      >
        <ReactMarkdown>{lesson.payload.markdown || ""}</ReactMarkdown>
      </article>
      <div className="mt-6 pt-6 border-t border-gray-800 flex items-center justify-between">
        <p className="text-xs text-gray-500">Tiempo estimado: {lesson.payload.reading_time_min || lesson.duration_min} min</p>
        <button
          onClick={onCompleted}
          data-testid="lesson-complete-btn"
          aria-label="Marcar lección como completada"
          className="px-5 py-2 rounded-md bg-[#B84A0C] hover:bg-primary text-white text-sm font-semibold"
        >
          Marcar como completada
        </button>
      </div>
    </div>
  );
}
